module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_03@2x-5a4dd634ba97172080da9cf4ad341a61.webp";